/** Mirrors wss.socket-service-next `API_ERROR_CODES` (ack callback passes numeric code only). */
export const SOCKET_API_ERROR_CODES = {
  SOMETHING_WENT_WRONG: 10000,
  NO_DEVICE_WITH_UUID: 10021,
  NOT_AUTHORIZED_FOR_ACTION: 10027,
  DEVICE_DISABLED: 10007,
  MESSAGE_TYPE_NOT_ALLOWED: 10039
}

const SOCKET_API_ERROR_MESSAGES = {
  [SOCKET_API_ERROR_CODES.SOMETHING_WENT_WRONG]: 'Something went wrong. Try again.',
  [SOCKET_API_ERROR_CODES.NO_DEVICE_WITH_UUID]: 'This device is not available for chat on the server.',
  [SOCKET_API_ERROR_CODES.NOT_AUTHORIZED_FOR_ACTION]: 'You are not allowed to message this device.',
  [SOCKET_API_ERROR_CODES.DEVICE_DISABLED]: 'This device is disabled.',
  [SOCKET_API_ERROR_CODES.MESSAGE_TYPE_NOT_ALLOWED]: 'This message type is not allowed.'
}

/**
 * @param {unknown} ackError — socket.io ack first arg (usually a number)
 * @returns {Error}
 */
export function socketAckErrorToError (ackError) {
  const code = typeof ackError === 'number'
    ? ackError
    : ackError?.code
  const objectMessage =
    ackError != null && typeof ackError === 'object' && typeof ackError.error === 'string'
      ? ackError.error
      : null
  const message = (code != null && SOCKET_API_ERROR_MESSAGES[code]) ||
    objectMessage ||
    (typeof ackError === 'string' ? ackError : null) ||
    `Message could not be sent (error ${code ?? 'unknown'}).`
  const err = new Error(message)
  if (code != null) {
    err.code = code
  }
  return err
}
